type FinancialTransaction = {
  amount: number;
  type_id: number;
};

export const calculateFinancialTotals = (
  transactions: FinancialTransaction[],
  incomeTypeId = 1,
  expenseTypeId = 2,
) => {
  const totals = transactions.reduce(
    (result, transaction) => {
      const amount = Number(transaction.amount || 0);
      if (transaction.type_id === incomeTypeId) result.income += amount;
      if (transaction.type_id === expenseTypeId) result.expense += amount;
      return result;
    },
    { income: 0, expense: 0 },
  );

  return { ...totals, net: totals.income - totals.expense };
};
